import { dataAttribute, DataAttributes } from "@bps/fluent-ui";
import { Country } from "@libs/enums/country.enum.ts";
import { Permission } from "@libs/gateways/core/CoreGateway.dtos.ts";
import { routes } from "@libs/routing/routes.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { usePatientLabel } from "@ui-components/hooks/usePatientLabel.ts";
import { NavLink } from "@ui-components/navigation/Nav.tsx";

export const useAdminLinks = (): NavLink[] => {
  const { core, correspondence, document, formDesign, templateManagement } =
    useStores();

  const patientLabel = usePatientLabel();

  return [
    {
      name: "Incoming",
      path: routes.inbox.incoming,
      ...dataAttribute(DataAttributes.Element, "incoming")
    },
    {
      name: `Upload ${patientLabel} files`,
      path: routes.inbox.upload,
      showBorder: true,
      ...dataAttribute(DataAttributes.Element, "upload-patient-files")
    },

    {
      name: "ACC claims",
      path: routes.claims.basePath,
      tenantLocation: Country.NewZealand,
      showBorder: true,
      ...dataAttribute(DataAttributes.Element, "acc-claims")
    },
    {
      name: "Create a document",
      onClick: () => {
        correspondence.ui.setShowTemplatePicker(true);
      },
      permissions: undefined,
      showBorder: true,
      ...dataAttribute(DataAttributes.Element, "create-a-document")
    },
    {
      name: "Manage templates & forms",
      links: [
        {
          name: "Autofills",
          onClick: () => {
            document.setShowTemplateManagementModal(true, true);
          },
          permissions: undefined,
          showBorder: true,
          ...dataAttribute(DataAttributes.Element, "autofills")
        },
        {
          name: "Document templates",
          onClick: () => {
            document.setShowTemplateManagementModal(true);
          },
          permissions: undefined,
          showBorder: false,
          ...dataAttribute(DataAttributes.Element, "document-templates")
        },
        {
          name: core.isNZTenant ? "Email templates" : "SMS & email templates",
          onClick: () => {
            templateManagement.ui.setShowTemplateListModal(true);
          },
          permissions: [
            Permission.EmailTemplatesAllowed,
            Permission.TemplateManagementAllowed,
            Permission.TemplateManagementRead
          ],
          showBorder: true,
          ...dataAttribute(DataAttributes.Element, "sms-&-email-templates")
        },
        {
          name: "Online forms",
          onClick: () => {
            formDesign.ui.setShowFormDesignListModal(true);
          },
          permissions: undefined,
          showBorder: true,
          ...dataAttribute(DataAttributes.Element, "online-forms")
        }
      ],
      showBorder: true,
      ...dataAttribute(DataAttributes.Element, "manage-templates-&-forms")
    },
    {
      name: `Recent ${patientLabel}s`,
      path: routes.recentPatients.basePath,
      showBorder: true,
      ...dataAttribute(DataAttributes.Element, "recent-patients")
    },
    {
      name: "Communication history",
      path: routes.communicationHistory.basePath,
      ...dataAttribute(DataAttributes.Element, "comms-history")
    }
  ];
};
